module.exports = __webpack_public_path__ + "images/135_4096.jpg";